import React from 'react';

import { SidebarState } from './CollapsibleSidebar.type';

export const SidebarContext = React.createContext<SidebarState | undefined>(
  undefined,
);
